import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useCallback } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { MetisApp } from '@yuanfudao/metis-web-component';
import icSuccess from '../asset/login/ic_success.svg';
import icFail from '../asset/login/ic_fail.svg';
import lessModule from '../styles/reset/antd-message.module.less';
export var useMsgSuccess = function useMsgSuccess() {
  var _MetisApp$useApp = MetisApp.useApp(),
    antMessage = _MetisApp$useApp.message;
  var fn = useCallback(function (config) {
    if (typeof config === 'string') {
      return antMessage.success({
        content: config,
        className: lessModule.rewriteSuccess,
        icon: /*#__PURE__*/React.createElement("img", {
          className: "icon",
          src: icSuccess,
          alt: ""
        })
      });
    }
    return antMessage.success(_objectSpread(_objectSpread({}, config), {}, {
      className: lessModule.rewriteSuccess,
      icon: /*#__PURE__*/React.createElement("img", {
        className: "icon",
        src: icSuccess,
        alt: ""
      })
    }));
  }, [antMessage]);
  return fn;
};
// export const MsgSuccess = (config: string | Partial<ArgsProps>) => {
//   if (typeof config === 'string') {
//     return message.success({
//       content: config,
//       className: lessModule.rewriteSuccess,
//       icon: <img className="icon" src={icSuccess} alt="" />,
//     })
//   }
//   return message.success({
//     ...config,
//     className: lessModule.rewriteSuccess,
//     icon: <img className="icon" src={icSuccess} alt="" />,
//   })
// }
// export const MsgFail = (config: string | Partial<ArgsProps>) => {
//   const { message: antMessage } = App.useApp()
//   if (typeof config === 'string') {
//     return antMessage.error({
//       content: config,
//       className: lessModule.rewriteFail,
//       icon: <img className="icon" src={icFail} alt="" />,
//     })
//   }
//   return antMessage.error({
//     // @ts-ignore
//     ...config,
//     className: lessModule.rewriteFail,
//     icon: <img className="icon" src={icFail} alt="" />,
//   })
// }
export var useMsgFail = function useMsgFail() {
  var _MetisApp$useApp2 = MetisApp.useApp(),
    antMessage = _MetisApp$useApp2.message;
  var fn = useCallback(function (config) {
    if (typeof config === 'string') {
      return antMessage.error({
        content: config,
        className: lessModule.rewriteFail,
        icon: /*#__PURE__*/React.createElement("img", {
          className: "icon",
          src: icFail,
          alt: ""
        })
      });
    }
    return antMessage.error(_objectSpread(_objectSpread({}, config), {}, {
      className: lessModule.rewriteFail,
      icon: /*#__PURE__*/React.createElement("img", {
        className: "icon",
        src: icFail,
        alt: ""
      })
    }));
  }, [antMessage]);
  return fn;
};